import rules from '@anchor/vue-assets/src/plugins/form-rules';

export default {
  username: [rules.required],
  password: [rules.required],
};
